import { render, staticRenderFns } from "./RegisterDataRekening.vue?vue&type=template&id=c5edbfca&scoped=true&"
import script from "./RegisterDataRekening.vue?vue&type=script&lang=js&"
export * from "./RegisterDataRekening.vue?vue&type=script&lang=js&"
import style0 from "./RegisterDataRekening.vue?vue&type=style&index=0&id=c5edbfca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5edbfca",
  null
  
)

export default component.exports